module.exports = __webpack_public_path__ + "assets/icon-running-with-errors-component.1a61690f.svg";